<template>
  <div class="h-16 w-full flex items-center justify-center">
    <RiskScoringLabel cssClasses="h-full w-full flex items-center justify-center font-bold" :level="riskScoring.attributes.scoreLevel" />
  </div>
  <div class="mt-4">
    <div v-for="riskScoringRuleExecution in sortedExecutions" :key="riskScoringRuleExecution.id" class="w-full">
      <RiskScoringFactor
        v-if="riskScoringRuleExecution.attributes.level != 'low' && riskScoringRuleExecution.attributes.skipped != true"
        :score="riskScoringRuleExecution.attributes.score"
        :level="riskScoringRuleExecution.attributes.level"
        :message="riskScoringRuleExecution.attributes.justification" />
    </div>
  </div>
</template>

<script setup>

import RiskScoringLabel from "./RiskScoringLabel.vue";
import RiskScoringFactor from "./RiskScoringFactor.vue";
import { ref, computed } from "vue";

const props = defineProps({
  riskScoring: Object
});

const riskScoring = ref(props.riskScoring);

const sortedExecutions = computed(() => {
  const executions = (riskScoring.value?.relationships?.riskScoringRuleExecutions?.data || []).slice();
  const priority = {
    "high": 1,
    "medium": 2,
    "low": 3,
  };

  return executions.sort((a, b) => {
    const riskA = priority[a.attributes?.level?.toLowerCase()] || 4;
    const riskB = priority[b.attributes?.level?.toLowerCase()] || 4;
    return riskA - riskB;
  });
});

</script>
